import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { parseCookies } from '@cian/utils';
import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { pathOr } from 'ramda';
export function sendTeaserEvent(payload, action) {
  var _config$get;
  var started = Date.now();
  var config = getConfig();
  // Лимит на проверку появления pageType в объекте window
  var pageTypeTimeoutLimit = (_config$get = config.get('builders.postViewAnalyticsTeaserTimeout')) !== null && _config$get !== void 0 ? _config$get : 3000;
  function validatePageDataAndFetch(callback, payload, action) {
    var page = pathOr({
      pageType: undefined,
      siteType: undefined
    }, ['CianAnalytics', 'service', 'config', 'page'], window);
    if (Date.now() - started > pageTypeTimeoutLimit || page.pageType && page.siteType) {
      callback.bind(null, payload, action, page)();
    } else {
      setTimeout(validatePageDataAndFetch.bind(null, callback, payload, action), 100);
    }
  }
  validatePageDataAndFetch(fetchTeaser, payload, action);
}
function fetchTeaser(payload, action, page) {
  var _banner$id;
  var cid = parseCookies(document.cookie)['_CIAN_GK'];
  var teaserApiUrl = getTeaserApiUrl();
  if (!teaserApiUrl) {
    return;
  }
  var banner = payload.banner,
    bannerSource = payload.bannerSource,
    offerType = payload.offerType;
  fetch(teaserApiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      device_type: page.siteType,
      cid: cid,
      pageType: page.pageType,
      items: [_objectSpread({
        action: action,
        bannerId: (_banner$id = banner.id) === null || _banner$id === void 0 ? void 0 : _banner$id.toString(),
        bannerPlace: banner.place,
        bannerName: "".concat(banner.name, "_").concat(action),
        bannerSource: bannerSource,
        offerType: offerType,
        timestamp: Date.now(),
        dl: window.location.href
      }, banner.hitUrl && {
        hitUrl: banner.hitUrl
      })]
    })
  });
}
function getTeaserApiUrl() {
  var config = getConfig();
  var logger = getLogger();
  var soprExperimentsForTeaserUrl = config.get('soprExperimentsForTeaserUrl');
  if (!soprExperimentsForTeaserUrl) {
    logger.error('soprExperimentsForTeaserUrl is not defined', {
      domain: 'getTeaserApiUrl'
    });
    return null;
  }
  return "".concat(soprExperimentsForTeaserUrl, "teaser/");
}